import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { ArrowRight, Loader2 } from "lucide-react";
import { useLang } from "../../context/LangContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const EMPTY = { name: "", email: "", company: "", sector: "New Space", message: "" };

export const ContactForm = ({ type = "project", prefix = "contact", onSuccess }) => {
  const { t, lang } = useLang();
  const f = t.form;
  const [data, setData] = useState(EMPTY);
  const [loading, setLoading] = useState(false);
  const investor = type === "investor";
  const set = (k) => (e) => setData({ ...data, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API}/contact`, { ...data, sector: investor ? null : data.sector, request_type: type, language: lang });
      toast.success(f.ok);
      setData(EMPTY);
      onSuccess?.();
    } catch {
      toast.error(f.err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={submit} data-testid={`${prefix}-form`} className="grid gap-6 sm:grid-cols-2">
      <input required data-testid={`${prefix}-name-input`} className="field" placeholder={f.name} value={data.name} onChange={set("name")} />
      <input required type="email" data-testid={`${prefix}-email-input`} className="field" placeholder={f.email} value={data.email} onChange={set("email")} />
      <input data-testid={`${prefix}-company-input`} className="field" placeholder={investor ? f.fund : f.company} value={data.company} onChange={set("company")} />
      {!investor && (
        <select data-testid={`${prefix}-sector-select`} className="field cursor-pointer [&>option]:bg-[#0a0a0b]" value={data.sector} onChange={set("sector")} aria-label={f.sector}>
          {f.sectors.map((s) => <option key={s} value={s}>{s}</option>)}
        </select>
      )}
      <textarea
        required={!investor}
        rows={4}
        data-testid={`${prefix}-message-input`}
        className="field resize-none sm:col-span-2"
        placeholder={investor ? f.messageInv : f.message}
        value={data.message}
        onChange={set("message")}
      />
      <div className="flex flex-col gap-5 sm:col-span-2 sm:flex-row sm:items-center sm:justify-between">
        <p className="max-w-xs text-xs text-white/40">{f.consent}</p>
        <button type="submit" disabled={loading} data-testid={`${prefix}-submit-button`} className="btn-gold group w-fit disabled:opacity-70">
          {loading ? <><Loader2 className="h-4 w-4 animate-spin" />{f.sending}</> : <>{f.submit}<ArrowRight className="h-4 w-4 transition-transform duration-500 group-hover:translate-x-1" /></>}
        </button>
      </div>
    </form>
  );
};
